import { swapAssetsNetworks, bareAssets } from '@/utils/constants.js'
export default {
  data () {
    return {
      swapAssetsNetworks,
      assets: bareAssets
    }
  },
  methods: {
    async getSwapPairsAssetsDetails () {
      this.isLoading = true
      await this.$store
        .dispatch('bridge/getSwapPairsAssetsDetails')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getSavedBeneficiaries () {
      this.isLoading = true
      await this.$store
        .dispatch('bridge/getSavedBeneficiaries', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async initiateSwap (swapDetails) {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('bridge/initiateSwap', swapDetails)
        .then(() => {
          this.isLoading = false
          this.goToConfirmationScreens()
        })
        .catch(() => {
          this.isLoading = false
          vm.$notify({
            title: this.httpErrorMessage.customMessage,
            message: this.httpErrorMessage.backendMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getSwappedPairDetailsById (swapPairId) {
      await this.$store
        .dispatch('bridge/getSwappedPairDetailsById', swapPairId)
        .then(() => {
          // this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
    },
    async handleFilter () {
      const payload = {
        fromAsset: this.filterInfo.fromAsset,
        fromNetwork: this.filterInfo.fromNetwork,
        toAsset: this.filterInfo.toAsset,
        toNetwork: this.filterInfo.toNetwork,
        from: this.filterInfo.from,
        to: this.filterInfo.to,
        sort_direction_desc: this.filterInfo.sort_direction_desc,
        sort_by: this.filterInfo.sort_by,
        status: this.filterInfo.status,
        page: this.payload.page,
        size: this.payload.size
      }
      this.isLoading = true
      await this.$store
        .dispatch('bridge/getSwappedTransactions', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
    }
  },
  computed: {
    filterInfo () {
      return this.$store.state.bridge.filterInfo
    },
    isFilterUse () {
      return this.$store.state.bridge.filterUse
    },
    swapPairAssetsDetails () {
      let swapDetails = {
        fee: 0,
        feePercentage: 0,
        feeCap: 0
      }
      if (this.swapPairsAssetsDetails?.length > 0) {
        swapDetails = this.swapPairsAssetsDetails.find((swapPair) => {
          return (
            swapPair.fromAsset === this.fromSwapAssetDetails?.currency &&
            swapPair.fromNetwork ===
              this.fromSwapAssetDetails?.networkShortName &&
            swapPair.toAsset === this.toSwapAssetDetails?.currency &&
            swapPair.toNetwork === this.toSwapAssetDetails?.networkShortName &&
            swapPair.isEnabled
          )
        })
      }
      return swapDetails
    },
    swapPairsAssetsDetails () {
      return this.$store.state.bridge.swapPairsAssetsDetails.pairs || []
    },
    // from asset
    fromSwapAssetDetails () {
      return this.$store.state.bridge.fromSwapAssetDetails
    },
    // to asset
    toSwapAssetDetails () {
      return this.$store.state.bridge.toSwapAssetDetails
    },
    isFromAssetSelected () {
      return this.fromSwapAssetDetails
    },
    isToAssetSelected () {
      return this.toSwapAssetDetails
    }
  }
}
